<template>
	<div class="">
		<b-navbar toggleable="md" type="dark" variant="info">
	      <b-container class="justify-content-center">
	        <b-navbar-brand to="/signin" class="font-30">
	          GreatGrowth
	        </b-navbar-brand>
	      </b-container>
	    </b-navbar>
	    <div class="container">
		<form @submit.prevent="submit()" class="text-left signinmentor border rounded py-4 px-5 mt-5 col-8 mx-auto" >
			<div v-if="loginError" class="alert alert-danger text-center" role="alert" v-html="textError" :class="{'shake animated': animated}">
	     
	        </div>
	        <b-form-group id="input-group-email" label="E-mail"  label-for="input-email">
	            <b-form-input
	                id="input-email"
	                type="email"
	                required
	                v-model="login.email"
	                placeholder="example@gmail.com"
	            ></b-form-input>
	        </b-form-group>

	        <b-form-group id="input-group-2" label="Password" label-for="input-password">
	            <b-form-input
	                id="input-password"
	                type="password"
	                required
	                 v-model="login.password"
	                placeholder="Password"
	            ></b-form-input>
	        </b-form-group>
	        <b-button 
	        type="submit"
	            block 
	            pill 
	            variant="outline-primary" 
	            class="btn-sigin bg my-2  not-shadow-active">
	            SIGN IN</b-button>
    	</form>
    	</div>
	</div>
</template>
<script>
import {HTTPTICKET,HTTPMentor} from "@/axios.js";
	export default{
		data () {
		    return {
		      loading:false,
		      login:{
		          email:'',
		          password:'',
		      },
		      textError:'',
		      loginError:false,
		      mentor:{
		          email:'',
		          password:'',
		      },
		      signinmentor:false,
			  mentorUrl:process.env.VUE_APP_URL_MENTOR,
			  animated:false
		    }
		},
		methods:{
			submit(){
				let data ={
					email:this.login.email,
					password:this.login.password,
					projectCode:"oZcIppU-VBIx9KO",
					redirectUrl:""
				}
				console.log(HTTPTICKET.defaults.baseURL)
				console.log(data)
				HTTPTICKET.post('/api/login/export',data).then(res =>{
					console.log('/api/login/export',res)
					if(res.data.success){
						this.$store.commit('setUser',res.data.obj.objUser)
						let data ={
							key:'token',
							value:res.data.tokenAuth
						}
						this.$store.commit('updateUser',data)
						let level ={
							key:'userLevel',
							value:res.data.obj.objUser.userLevel
						}
						this.$store.commit('updateUser',level)
						this.$router.push("/");
					}else{
						if(res.data.data == "login not access."){
							this.textError = "Sorry for your inconvenience :( We're not allowed mentor access to this page. Please sign in <a href='"+this.mentorUrl+"signin' target='_bank'>here</a>"
						}else{
							this.textError = "Invalid E-mail or password"
						}
						this.animated = true
						setTimeout(() => {
							this.animated = false
						},1000)
						this.loginError = true
	                    setTimeout(()=>{
	                      this.loginError = false
	                    },5000)
					}
				})
			}
		}
	}
</script>

<style scoped>
	.signinmentor{
		padding: 30px;
	}

	.bg-info{
	  background-color: rgb(13, 106, 202) !important;
	}
	.bg{
		background-color: rgb(13, 106, 202) !important;
		opacity: 0.6;
	}
	.bg:hover{
		/* background-color: rgb(13, 106, 202) !important; */
		opacity: 1;
	}
</style>


// WEBPACK FOOTER //
// src/components/SigninMentor.vue